import { useEffect, useState } from 'react';
import { RegionsService } from '#services/regions';
import { ListedRegionResponse } from 'types';

const useRegions = () => {
  const regionsService = new RegionsService();

  const [data, setData] = useState<ListedRegionResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [isLast, setIsLast] = useState<boolean>(false);

  const getRegions = async () => {
    setLoading(true);

    try {
      const result = await regionsService.getRegions({
        page: page,
        size: size,
      });

      setData(result.data);
      setTotal(result.total);
      setIsLast(result.isLast);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRegions();
  }, []);

  useEffect(() => {
    getRegions();
  }, [page, size]);

  return {
    data,
    loading,
    page,
    size,
    total,
    isLast,
    setPage,
    setSize: (pageSize: number) => {
      console.log('pageSize', pageSize);

      setSize(pageSize);
    },
    getRegions,
  };
};

export default useRegions;
